'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$resource',
    function ($resource) {
        return $resource('api/src-categories/:srcCategoryId', null, {
            getAll: {method: 'GET'},
            get: {method: 'GET'},
            create: {method: 'POST'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            enable: {url: 'api/src-categories/:srcCategoryId/enable', method: 'PUT'},
            delete: {url: 'api/src-categories/:srcCategoryId/delete', method: 'PUT'},
            getDefault: {url: 'api/src-categories/default', method: 'GET'},
            setDefault: {url: 'api/src-categories/:srcCategoryId/default', method: 'PUT'},
            isUniqueName: {url: 'api/src-categories/unique/name/:name', method: 'GET'},
            tree: {url: 'api/src-categories/tree', method: 'GET'},
            root: {url: 'api/src-categories/root', method: 'GET'},
            childs: {url: 'api/src-categories/:srcCategoryId/childs', method: 'GET'},
            path: {url: 'api/src-categories/:srcCategoryId/path', method: 'GET'},
        });
    }];